import * as Actions from '../actions/testForm';
import SiteConfig from '../site.config.json';

/**
 * テストディレクトリを取得する。
 * @param linkUrlParam テスト問題文/解説情報
 * @param text 問題文/解説
 * @return テストディレクトリ
 */
export const getLinkUrl = (linkUrlParam: Actions.ILinkUrl, text: string) => {
	let keyword = text;
	const lang = getContentsLangDirName(linkUrlParam.lang);
	if (keyword.indexOf('&lt;!--%%SRCPATH%%--&gt;') !== -1) {
		let url = SiteConfig.tsqPath + '/tsq/pkg/action/el/contents/';
		url =
			url +
			`${linkUrlParam.careerID}&${
				linkUrlParam.preview ? '1' : '0'
			}/${lang}/${linkUrlParam.testID}/`;
		keyword = keyword.replace(/&lt;!--%%SRCPATH%%--&gt;/g, url);
	}
	if (keyword.indexOf('&lt;!--%%ASSETPATH%%--&gt;') !== -1) {
		let url = SiteConfig.tsqPath + '/tsq/pkg/action/el/contents/';
		url =
			url +
			`${linkUrlParam.careerID}&${
				linkUrlParam.preview ? '1' : '0'
			}/${lang}/`;
		keyword = keyword.replace(/&lt;!--%%ASSETPATH%%--&gt;/g, url);
	}
	return keyword;
};

/**
 * 言語コードに対応するコンテンツの言語(国)ディレクトリ名を取得する。
 * @param langCd 言語コード
 * @return 言語ディレクトリ名
 */
export const getContentsLangDirName = (langCd: string) => {
	let langDirName: string = '';
	if ('EN' === langCd.toLocaleUpperCase()) {
		langDirName = 'US';
	} else if ('JA' === langCd.toLocaleUpperCase()) {
		langDirName = 'JP';
	} else if ('ZH' === langCd.toLocaleUpperCase()) {
		langDirName = 'CN';
	}
	return langDirName;
};



// WEBPACK FOOTER //
// ./src/utils/ReplaceLinkUrl.ts